import React from 'react';
import './Recognition.css'
const Recognition = () => {
    return (
        <div className='mb-10'>
            <h2 className='text-2xl lg:text-4xl mb-4 mt-5 text-center  font-extrabold text-black'>Awards & Recognitions</h2>
            <img className='awards-img ' src='https://i.ibb.co/kD1sVR5/282f014f-awards-banner.png' alt='' />
        </div>
    );
};

export default Recognition;